// Port of api/fuel/app/classes/controller/api/monty/session/synctype.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import User from 'offline/model/user'

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id') || false
	var user = userId ? User.with_id(userId) : false
	var type = params.type

	if (!user) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	if (user.get_upgrade()) {
		return Promise.reject({ error: Constants.API_ERROR_SYNC_NOTALLOWED, offline: true })
	}

	DB.run('UPDATE user SET user_sync_type = ? WHERE user_id = ?', [type, user.get_id()])

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: {}
		}
	})
}
